import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import { CloseIcon } from 'assets/icons';
import relifLogoAzul from 'assets/images/logos/RelifLogoAzul.png';
import rLogoAzul from 'assets/images/logos/RLogoAzul.png';
import { useSidebar } from 'contexts/SidebarContext';
import type React from 'react';
import { useNavigate } from 'react-router-dom';

interface SidebarHeaderProps {
  onMobileClose: () => void;
}

const SidebarHeader: React.FC<SidebarHeaderProps> = ({ onMobileClose }) => {
  const { collapsed } = useSidebar();
  const navigate = useNavigate();

  return (
    <>
      {/* Mobile close button */}
      <Box sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'flex-end', px: 1, pt: 1 }}>
        <IconButton onClick={onMobileClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Logo — margin follows brand manual (x = height of R glyph ≈ 12px) */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: collapsed ? 1.5 : '12px',
          pt: collapsed ? 1.5 : '12px',
          pb: collapsed ? 1 : '8px',
        }}
      >
        <Box
          sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={() => navigate('/clients')}
        >
          <img
            src={collapsed ? rLogoAzul : relifLogoAzul}
            alt="Relif"
            style={{ height: '90px', width: 'auto', transition: 'height 0.2s ease' }}
          />
        </Box>
      </Box>
    </>
  );
};

export default SidebarHeader;
